// ============================================================================
// FSA NOTE MODAL — REVIEWER NOTES PANE (PRIVATE — NOT PRINTED)
// ============================================================================
// PRIVATE auditor scratchpad bound to workspace.notes_text. Used for
// review points, cross-references, partner queries, working-paper-only
// remarks. NEVER prints in the deliverable PDF. FSA-3 working-papers
// mode will surface these in an internal print for audit-file purposes.
//
// Distinct from the DELIVERABLE Note Text (workspace.note_remark), which
// is edited on the Main Note pane and DOES print at Schedule III
// footnote level below the Note's class total.

import React from 'react';
import IconSystem from 'icon-collection/icon-systems';

interface Props {
  notesText: string | null | undefined;
  setNotesText: (text: string) => void;
  readOnly: boolean;
}

const AuditorNotesPane: React.FC<Props> = ({ notesText, setNotesText, readOnly }) => {
  return (
    <div style={paneStyle}>
      <div style={hintStyle}>
        <IconSystem.lock size={13} />
        <span>
          <strong>Reviewer Notes (private)</strong> — internal scratchpad for
          cross-references, partner queries, sign-off notes, and review
          points. <strong>Not printed</strong> in the deliverable PDF. For
          notes that should appear in the printed financial statements, use
          the <em>Note Text</em> field on the Main Note pane.
        </span>
      </div>
      <textarea
        className="form-input form-textarea"
        value={notesText ?? ''}
        readOnly={readOnly}
        disabled={readOnly}
        onChange={e => setNotesText(e.target.value)}
        placeholder="Cross-references, partner queries, working-paper notes…"
        style={textareaStyle}
      />
    </div>
  );
};

const paneStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  height: '100%',
  padding: '0.75rem 0.75rem',
};
const hintStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 8,
  fontSize: '0.72rem',
  color: 'var(--text-primary)',
  background: '#fef3c7',
  padding: '8px 10px',
  borderRadius: 4,
  border: '1px solid #fde68a',
  lineHeight: 1.5,
};
const textareaStyle: React.CSSProperties = {
  width: '100%',
  flex: 1,
  minHeight: 200,
  fontFamily: 'inherit',
  fontSize: '0.85rem',
  resize: 'vertical',
};

export default AuditorNotesPane;
